import { render } from "./lotto.vue?vue&type=template&id=c429b2ea"
import script from "./lotto.vue?vue&type=script&lang=js"
export * from "./lotto.vue?vue&type=script&lang=js"

import "./lotto.vue?vue&type=style&index=0&id=c429b2ea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__